import { render, staticRenderFns } from "./ModelContainer.vue?vue&type=template&id=12af3320&scoped=true&"
import script from "./ModelContainer.vue?vue&type=script&lang=js&"
export * from "./ModelContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12af3320",
  null
  
)

export default component.exports